import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './modules/material.module';
import { TableComponent } from '../core/components/table/table.component';
import { DataPropertyGetterPipe } from '../core/components/table/data-property-getter-pipe/data-property-getter.pipe';
import { ErrorDialogService } from './errors/error-dialog.service';
import { LoadingDialogService } from './loading/loading-dialog.service';
import { LoadingDialogComponent } from './loading/loading-dialog/loading-dialog.component';
import { ErrorDialogComponent } from './errors/error-dialog/error-dialog.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { LabelViewComponent } from './label-view/label-view.component';
import { FormsModule } from '@angular/forms';
import { SortByPipe } from './pipes/sortBy/sort-by.pipe';
import { SnackBarComponent } from './snack-bar/snack-bar.component';
import { UniqueByPipe } from './pipes/uniqueBy/unique-by.pipe';
import { InvalidDialogComponent } from './errors/invalid-dialog/invalid-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { AddtionalChargesComponent } from './addtional-charges/addtional-charges.component';
import { ChargeSelectorComponent } from './addtional-charges/charge-selector/charge-selector.component';
import { TwoDigitDecimaNumberDirective } from './directives/two-decimal-filter';
import { ChargesComponent } from './charges/charges.component';
import { InvoiceReferenceComponent } from './invoice-reference/invoice-reference.component';
import { AddReferenceComponent } from './invoice-reference/add-reference/add-reference.component';
import { FtrItnFilterDirective } from './directives/itn-filter';
import { MrnFilterDirective } from './directives/mrn-filter';
import { DgpackagesComponent } from './dgpackages/dgpackages/dgpackages.component';

@NgModule({
  declarations: [
    TableComponent,
    DataPropertyGetterPipe,
    LoadingDialogComponent,
    ErrorDialogComponent,
    LabelViewComponent,
    SnackBarComponent,
    SortByPipe,
    UniqueByPipe,
    InvalidDialogComponent,
    AddtionalChargesComponent,
    ChargeSelectorComponent,
    TwoDigitDecimaNumberDirective,
    FtrItnFilterDirective,
    MrnFilterDirective,
    ChargesComponent,
    InvoiceReferenceComponent,
    AddReferenceComponent,
    DgpackagesComponent,
  ],
  imports: [CommonModule, MaterialModule, PdfViewerModule, FormsModule, TranslateModule],
  exports: [
    MaterialModule,
    PdfViewerModule,
    TranslateModule,
    TableComponent,
    DataPropertyGetterPipe,
    LoadingDialogComponent,
    SortByPipe,
    UniqueByPipe,
    InvalidDialogComponent,
    AddtionalChargesComponent,
    ChargeSelectorComponent,
    ChargesComponent,
    DgpackagesComponent,
  ],
  providers: [ErrorDialogService, LoadingDialogService],
})
export class SharedModule {}
